import React, { useEffect, useMemo } from 'react';
import { Button, Center, Divider, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, useDisclosure } from '@chakra-ui/react';
import MuiIcon from 'components/MuiIcon';
import { t } from 'i18next';
import { useParams } from 'react-router-dom';
import { useGetOneService, useGet3thPartyServices } from 'shared/api/requests/services';
import useGetColors from 'shared/hooks/useGetColors';
import { PathsParams, PathsE, ModuleE } from 'shared/routes';
import Form from './Form';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { CreateMessageFormT, createMessageResolver, getCreateMessageValues } from 'shared/form-values/dialog_messages';
import { ActorDTO } from 'shared/api/types/services';

const CreateMessageButton = () => {
  const { serviceId } = useParams<PathsParams[PathsE.DIALOG_MESSAGES]>();
  const {
    gray800,
    white,
    gray100,
    brand500,
    brand400,
  } = useGetColors();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const { data: currentService } = useGetOneService({
    pathParams: { serviceId },
    params: undefined
  });
  const { useGetServiceModule, useAddDialogMessage } = useGet3thPartyServices({
    domain: currentService?.domain,
    token: currentService?.token,
    module: ModuleE.DIALOG_MESSAGES
  });

  const { isPending, mutate } = useAddDialogMessage();

  // const { data } = useGetServiceModule({
  //   params: {} as FixMeLater,
  //   pathParams: {},
  // });

  // const firstActor = useMemo(() => (
  //   data?.pages?.[0].data?.[0] ?? null
  // ) as unknown as ActorDTO, [data]);

  const methods = useForm<CreateMessageFormT>({
    defaultValues: getCreateMessageValues(),
    resolver: createMessageResolver,
    mode: "onChange"
  });

  // useEffect(() => {
  //   if (!firstActor) return;
  //   methods.setValue('clientID', firstActor.id);
  //   methods.setValue('clientName', firstActor.name);
  // }, [firstActor, isOpen]);

  const onSubmit: SubmitHandler<CreateMessageFormT> = (values) => {
    return mutate(values, {
      onSuccess: () => {
        onClose();
        methods.reset(getCreateMessageValues());
      },
    });
  };

  return (
    <>
      <Button
        color="white"
        _hover={{
          bgColor: "brand.400",
        }}
        bgColor="brand.500"
        isLoading={isPending}
        borderRadius="8px"
        leftIcon={<MuiIcon name="add_circle" color="white" />}
        onClick={onOpen}
      >
        {t('buttons.addNewMessage')}
      </Button>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t('Creating new message')}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormProvider {...methods}>
              <form onSubmit={methods.handleSubmit(onSubmit)}>
                <Form />
                <Divider my="20px" />
                <Center w="100%">
                  <Button
                    color={gray800}
                    bgColor={gray100}
                    borderRadius="8px"
                    onClick={onClose}
                    w="100px"
                  >
                    {t('buttons.cancel')}
                  </Button>
                  <Button
                    color={white}
                    bgColor={gray100}
                    borderRadius="8px"
                    backgroundColor={brand500}
                    _hover={{
                      background: brand400,
                    }}
                    ml="20px"
                    w="100px"
                    type="submit"
                  >
                    {t('buttons.create')}
                  </Button>
                </Center>
              </form>
            </FormProvider>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}

export default CreateMessageButton;
